import React from 'react';
import { Chip } from '@mui/material';
import {
  isPendingTransactionStatus,
  TRANSACTION_STATUSES,
  isReturnedAvailableToReclaimTransactionStatus,
  isReturnedPendingReturnToBankTransactionStatus,
  isReturnedTransactionStatus,
  isStartedTransactionStatus,
} from '@/utility';
import useTranslatedTransactionStatuses from '@/hooks/useTranslatedTransactionStatuses';

const TransactionStatusChip = ({ status, voidSent }) => {
  const { getTranslatedStatus } = useTranslatedTransactionStatuses();

  const getStatusColor = (statusValue) => {
    if (!statusValue) return 'default';

    const normalizedStatus = statusValue.toLowerCase();

    switch (normalizedStatus) {
      case TRANSACTION_STATUSES.SUCCESS.toLowerCase():
        return 'success';
      case TRANSACTION_STATUSES.ERROR.toLowerCase():
      case TRANSACTION_STATUSES.VOIDED.toLowerCase():
        return 'error';
      case TRANSACTION_STATUSES.SENT_UNCASHED.toLowerCase():
        return 'info';
      default:
        if (isReturnedTransactionStatus(normalizedStatus)) {
          return 'error';
        }
        if (isReturnedAvailableToReclaimTransactionStatus(normalizedStatus)) {
          return 'success';
        }
        if (isReturnedPendingReturnToBankTransactionStatus(normalizedStatus)) {
          return 'warning';
        }
        if (isPendingTransactionStatus(normalizedStatus)) {
          return 'warning';
        }
        if (isStartedTransactionStatus(normalizedStatus)) {
          return 'info';
        }
        return 'default';
    }
  };

  const isVoidedStatus =
    status?.toLowerCase() === TRANSACTION_STATUSES.VOIDED.toLowerCase();

  return (
    <div style={{ display: 'flex', gap: '4px' }}>
      <Chip
        label={getTranslatedStatus(status)}
        size='small'
        color={getStatusColor(status)}
        variant='outlined'
      />
      {voidSent && isVoidedStatus && (
        <Chip
          label='Added to positive pay'
          size='small'
          color='default'
          variant='outlined'
        />
      )}
    </div>
  );
};

export default TransactionStatusChip;
